module.exports = {"621228100":"城关镇","621228101":"站儿巷镇","621228102":"西坡镇","621228103":"杨店镇","621228104":"显龙镇","621228105":"云屏镇","621228201":"左家乡","621228203":"鱼池乡","621228204":"兴化乡","621228207":"张家乡","621228210":"泰山乡","621228212":"金洞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621228.json
// module id = 3101
// module chunks = 0